import { SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { Images } from 'assets/images';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { deviceMin } from 'utils/styles/breakpoints';

export const HotOfferSectionContainer = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  width: 100%;
  // TODO
  //background-image: url(${Images.hotBack});
`;

export const HotOffersBlock = styled.div`
  .desc {
    margin-bottom: 40px;
    ${FONTS.font24}
    ${FONT_FAMILY.FontBold}
    color: ${COLORS.grey};

    @media (min-width: ${SIZE.mobile}) {
      padding: 0;
      margin-bottom: 11px;
      text-align: center;
      ${FONTS.font24}
    }

    @media (min-width: ${SIZE.tablet}) {
      ${FONTS.font16}
      text-align: center;
    }
  }
  .slick-slider {
    margin-top: -20px;

    @media (min-width: ${SIZE.mobile}) {
      width: 270px;
      height: auto;
    }

    @media (min-width: ${SIZE.tablet}) {
      width: 270px;
      height: 372.9px;
    }

    @media (min-width: ${SIZE.desktop}) {
      width: 1000px;
      height: 585px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      width: 1000px;
      height: 586px;
    }
  }
`;

export const HotOffersWrapper = styled.div`
  @media (min-width: ${SIZE.desktop}) {
    margin-top: 100px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    margin-top: 220px;
  }
`;
export const HotTitleWrapper = styled.div`
  display: flex;
  align-items: center;

  @media ${deviceMin.mobileS} {
    padding: 50px 0;
    margin-bottom: 11px;
  }
  @media ${deviceMin.mobileL} {
    padding: 150px 0;
  }
  @media ${deviceMin.tablet} {
    margin-bottom: 24px;
    padding: 200px 0;
    margin-top: 200px;
  }
  @media ${deviceMin.laptopL} {
    margin-bottom: 0;
    padding: 200px 0;
    margin-top: 200px;
  }
`;

export const LogoHotOffers = styled.img`
  @media (min-width: ${SIZE.mobile}) {
    width: 62px;
    height: 57px;
    margin: 0px 0px 1px 40px;
  }

  @media (min-width: ${SIZE.iphone}) {
    width: 62px;
    height: 57px;
    margin: 0px 0px 1px 60px;
  }

  @media (min-width: ${SIZE.tablet}) {
    width: 98px;
    height: 90px;
    margin: 0px 0px 1px 100px;
  }

  @media (min-width: ${SIZE.desktop}) {
    width: 122px;
    height: 112px;
    margin: 0px 0px 1px 170px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    width: 173px;
    height: 160px;
    margin: 0px 0px 1px 170px;
  }
`;

export const HotOffersTitle = styled.p`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  color: ${COLORS.darkBlueBlack};
  margin-left: 32px;

  @media (min-width: ${SIZE.mobile}) {
    margin-left: 20px;
    width: 123px;
    ${FONTS.font16}
  }

  @media (min-width: ${SIZE.tablet}) {
    margin-left: 25px;
    width: 123px;
    ${FONTS.font16}
  }

  @media (min-width: ${SIZE.desktop}) {
    margin-left: 23px;
    width: 158px;
    ${FONTS.font20}
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    margin-left: 32px;
    ${FONTS.font24}
    width: 211px;
    text-align: inherit;
  }

  span {
    color: ${COLORS.yellow};
  }
`;

export const Airline = styled.img`
margin-left: 142px;
@media (min-width: ${SIZE.mobile}) {
        display: none;
    }
    
@media (min-width: ${SIZE.desktop}) {
        display: block;
        width: 383.95px;
        height: 365.29px;
     }
    
@media (min-width: ${SIZE.bigDesktop}) {
       
        width: 535.18px;
        height: 509.17px;
    }
}
`;

export const SliderInfo = styled.div`
    display: flex;
    @media (min-width: ${SIZE.mobile}) {
            margin-top: 60px;
        }
        
    @media (min-width: ${SIZE.mobile}) {
            margin-top: 60px;
        }
        
    @media (min-width: ${SIZE.tablet}) {
            margin-top: 60px;
        }
        
    @media (min-width: ${SIZE.desktop}) {
            margin-left: 94px;
        }
        
    @media (min-width: ${SIZE.bigDesktop}) {
            margin-left: 0;
        }

    .slick-next:before,
    .slick-prev.slick-disabled:before,
    .slick-next.slick-disabled:before {
            display: none;
        }
    }
   
`;

export const HotOffersCardWrapper = styled.div`
  height: 585px;
`;
